module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHg9IjAuNDk3MDciIHdpZHRoPSIxNy4xNzAyIiBoZWlnaHQ9IjE2IiByeD0iMyIgZmlsbD0iI0VCQ0ZBMyIvPg0KPHJlY3QgeD0iMy41NjM0OCIgeT0iNy4xMTQwMSIgd2lkdGg9IjEwLjM2NjkiIGhlaWdodD0iMi4yMjE0OCIgZmlsbD0iYmxhY2siLz4NCjxyZWN0IHg9IjkuODU1NDciIHk9IjMuMDQxMDIiIHdpZHRoPSIxMC4zNjY5IiBoZWlnaHQ9IjIuMjIxNDgiIHRyYW5zZm9ybT0icm90YXRlKDkwIDkuODU1NDcgMy4wNDEwMikiIGZpbGw9ImJsYWNrIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/add.svg
// module id = UJ+Z
// module chunks = 1